import client from "./client";

const usersApi = {
  list(params = {}) {
    return client.get("/users", { params }).then((r) => r.data);
  },

  create(body) {
    return client.post("/users", body).then((r) => r.data);
  },

  update(id, body) {
    return client.patch(`/users/${id}`, body).then((r) => r.data);
  },

  remove(id) {
    return client.delete(`/users/${id}`).then((r) => r.data);
  },
};

export default usersApi;
